import { render } from "./IconSettingsSvg.vue?vue&type=template&id=2a91ca5c"
const script = {}

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__